export default {
  name: 'account--productGroupName',
};